var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 31,
    viewBox: "0 0 64 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1818 7.5H23.8182C23 7.5 22 7.5 22 9.27976V12.8304H23.8182V9.26196H40.1818V21.7469H23.8182V18.1696H22L22 22.5211C22 23.5 23 23.5 23.8182 23.5H40.1818C41.1818 23.5 42 23.5 42 21.738V9.27976C42 8.80774 41.841 8.33377 41.5 8C41.159 7.66623 40.664 7.5 40.1818 7.5ZM31.0909 19.0595L34.7273 15.5L31.0909 11.9405V14.6101H22V16.3899H31.0909V19.0595Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputTab);
export default __webpack_public_path__ + "static/media/inputTab.9f9caed04afc81cd9efad4c3d0c9ae53.svg";
export { ForwardRef as ReactComponent };